import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styles from "./ParameterSettings.local.scss";
import _ from "i18n";
import { setAuthorizationParameters } from "Actions";
import { Collapse, Radio, Switch } from "antd";
import CollapsePanel from "antd/lib/collapse/CollapsePanel";

class AuthorizationsParameters extends Component {
  constructor(props) {
    super(props);
    let parameterSettings = this.props.data.defaultAuthParameters;
    this.state = {
      authParameters: {
        superadmin: parameterSettings.superadmin,
        admin: parameterSettings.admin,
        partner: parameterSettings.partner,
        collaborator: parameterSettings.collaborator,
        supervisor: parameterSettings.supervisor,
        none: parameterSettings.none
      },
      activeTab: "SUPERADMIN"
    };
  }

  categories = [
    {
      id: "SUPERADMIN",
      label: _("SUPERADMIN")
    },
    {
      id: "ADMIN",
      label: _("ADMIN")
    },
    {
      id: "PARTNER",
      label: _("partner")
    },
    {
      id: "COLLABORATOR",
      label: _("COLLABORATOR")
    },
    {
      id: "SUPERVISOR",
      label: _("SUPERVISOR")
    },
    {
      id: "NONE",
      label: _("NONE")
    }
  ];

  handleTabChange = activeTab => {
    this.setState(prevState => ({
      ...prevState,
      activeTab
    }));
  };

  handleToggle = value => {
    this.setState(prevState => ({
      ...prevState,
      expanded: value
    }));
  };

  handleParameterChange = (role, path, value) => {
    const { dispatch, handleDisabledSave } = this.props;
    handleDisabledSave(false);

    this.setState(prevState => {
      const keys = path.split(".");

      const updateNestedState = (obj, keys, value) => {
        if (keys.length === 1) {
          return { ...obj, [keys[0]]: value };
        }

        const [firstKey, ...restKeys] = keys;
        return {
          ...obj,
          [firstKey]: updateNestedState(obj[firstKey] || {}, restKeys, value)
        };
      };

      return {
        ...prevState,
        authParameters: {
          ...prevState.authParameters,
          [role]: updateNestedState(
            prevState.authParameters[role] || {},
            keys,
            value
          )
        }
      };
    });

    dispatch(setAuthorizationParameters(role, path, value));
  };

  renderViewDataBySwitch(role, title, path, allowViewData) {
    return (
      <div>
        <div className={"switch"}>
          <span className="sidebar_role">{_(title)}</span>
        </div>
        <Radio.Group
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: 15,
            marginLeft: 80
          }}
          onChange={event =>
            this.handleParameterChange(role, path, event.target.value)
          }
          value={allowViewData}
          options={[
            {
              value: 0,
              label: _("noAccess")
            },
            {
              value: 1,
              label: _("all")
            },
            {
              value: 10,
              label: _("personal")
            },
            {
              value: 11,
              label: _("partnership")
            },
            {
              value: 100,
              label: _("BU")
            },
            {
              value: 101,
              label: _("zone")
            },
            {
              value: 110,
              label: _("backup")
            }
          ]}
        />
      </div>
    );
  }

  renderSettings(role, authSetting) {
    const {
      activateNotifications,
      activateCarteNotifications,
      activateCalendarNotifications,
      dashboard,
      clients,
      collaborators,
      prestations,
      financial,
      reporting,
      capacityPlanning,
      settings,
      timesheet
    } = authSetting;
    return (
      <Fragment>
        <Collapse defaultActiveKey={["1"]}>
          <CollapsePanel header={_("generalPrivileges")} key="1">
            <div className={"switch"}>
              <span className="sidebar_role">{_("activateNotifications")}</span>
              <Switch
                checked={activateNotifications}
                onChange={val =>
                  this.handleParameterChange(role, "activateNotifications", val)
                }
              />
            </div>
            <div className={"switch"}>
              <span className="sidebar_role">
                {_("activateCarteNotifications")}
              </span>
              <Switch
                checked={activateCarteNotifications}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "activateCarteNotifications",
                    val
                  )
                }
              />
            </div>
            <div className={"switch"}>
              <span className="sidebar_role">
                {_("activateCalendarNotifications")}
              </span>
              <Switch
                checked={activateCalendarNotifications}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "activateCalendarNotifications",
                    val
                  )
                }
              />
            </div>
          </CollapsePanel>
          <CollapsePanel header={_("dashboardPrivileges")} key="2">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={dashboard.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "dashboard.allowAccess", val)
                }
              />
            </div>
          </CollapsePanel>
          <CollapsePanel header={_("clientsPrivileges")} key="3">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={clients.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "clients.allowAccess", val)
                }
              />
            </div>
            {clients.allowAccess && (
              <Fragment>
                {this.renderViewDataBySwitch(
                  role,
                  "viewPortfolioDataBy",
                  "clients.allowViewDataBy",
                  clients.allowViewDataBy
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowConfigurateBudget")}
                  </span>
                  <Switch
                    checked={clients.allowUpdateBudgetConfig}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "clients.allowUpdateBudgetConfig",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowUpdateClientSettings")}
                  </span>
                  <Switch
                    checked={clients.allowUpdateClientSettings}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "clients.allowUpdateClientSettings",
                        val
                      )
                    }
                  />
                </div>
              </Fragment>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("collaboratorsPrivileges")} key="4">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={collaborators.allowAccess}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "collaborators.allowAccess",
                    val
                  )
                }
              />
            </div>
            {collaborators.allowAccess && (
              <Fragment>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowConfigCollaborator")}
                  </span>
                  <Switch
                    checked={collaborators.allowConfigCollaborator}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowConfigCollaborator",
                        val
                      )
                    }
                  />
                </div>
                {this.renderViewDataBySwitch(
                  role,
                  "viewDataBy",
                  "collaborators.allowViewDataBy",
                  collaborators.allowViewDataBy
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessProdCapacity")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessCPr}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessCPr",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessPlans")}</span>
                  <Switch
                    checked={collaborators.allowAccessPlans}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessPlans",
                        val
                      )
                    }
                  />
                </div>
                {collaborators.allowAccessPlans && (
                  <Fragment>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromToDo")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromToDo}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromToDo",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromWIP")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromWIP}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromWIP",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromValidate")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromValidate}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromValidate",
                            val
                          )
                        }
                      />
                    </div>
                    <div className={"switch sub_tab"}>
                      <span className="sidebar_role">
                        {_("allowDragFromDone")}
                      </span>
                      <Switch
                        checked={collaborators.allowDragFromDone}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "collaborators.allowDragFromDone",
                            val
                          )
                        }
                      />
                    </div>
                  </Fragment>
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCalendar")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessCalendar}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessCalendar",
                        val
                      )
                    }
                  />
                </div>
                {collaborators.allowAccessCalendar && (
                  <div className={"switch sub_tab"}>
                    <span className="sidebar_role">
                      {_("allowValidateVacationRequest")}
                    </span>
                    <Switch
                      checked={collaborators.allowValidateVacationRequest}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "collaborators.allowValidateVacationRequest",
                          val
                        )
                      }
                    />
                  </div>
                )}
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessPlanification")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessPlanification}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessPlanification",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessFolderCapacity")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessFolderCapacity}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessFolderCapacity",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessFinancialState")}
                  </span>
                  <Switch
                    checked={collaborators.allowAccessFinancialState}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "collaborators.allowAccessFinancialState",
                        val
                      )
                    }
                  />
                </div>
              </Fragment>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("financialPrivileges")} key="5">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={financial.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "financial.allowAccess", val)
                }
              />
            </div>
            {financial.allowAccess && (
              <Collapse
                defaultActiveKey={["51"]}
                style={{
                  width: "82%",
                  marginLeft: "9%",
                  backgroundColor: "transparent"
                }}
              >
                <CollapsePanel header="Table Dynamique" key="51">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessDynamicTab")}
                    </span>
                    <Switch
                      checked={financial.dynamicTable.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.dynamicTable.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.dynamicTable.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "financial.dynamicTable.allowViewDataBy",
                      financial.dynamicTable.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Financial Sheet" key="52">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessFinancial")}
                    </span>
                    <Switch
                      checked={financial.financialState.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.financialState.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.financialState.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "financial.financialState.allowViewDataBy",
                      financial.financialState.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Forfait" key="53">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessForfait")}
                    </span>
                    <Switch
                      name="allowAccessForfait"
                      checked={financial.forfait.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.forfait.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.forfait.allowAccess && (
                    <div className={"switch"}>
                      <span className="sidebar_role">
                        {_("allowAccessRevision")}
                      </span>
                      <Switch
                        checked={financial.forfait.allowLaunchRevision}
                        onChange={val =>
                          this.handleParameterChange(
                            role,
                            "financial.forfait.allowLaunchRevision",
                            val
                          )
                        }
                      />
                    </div>
                  )}
                </CollapsePanel>
                <CollapsePanel header="Croissance" key="54">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessCroissance")}
                    </span>
                    <Switch
                      checked={financial.croissance.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "financial.croissance.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {financial.croissance.allowAccess && (
                    <Fragment>
                      {this.renderViewDataBySwitch(
                        role,
                        "viewDataBy",
                        "financial.croissance.allowViewDataBy",
                        financial.croissance.allowViewDataBy
                      )}
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessClientIn")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessIN}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessIN",
                              val
                            )
                          }
                        />
                      </div>
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessClientOut")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessOUT}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessOUT",
                              val
                            )
                          }
                        />
                      </div>
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessClientRisky")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessRisky}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessRisky",
                              val
                            )
                          }
                        />
                      </div>
                      <div className={"switch"}>
                        <span className="sidebar_role">
                          {_("allowAccessReview")}
                        </span>
                        <Switch
                          checked={financial.croissance.allowAccessReview}
                          onChange={val =>
                            this.handleParameterChange(
                              role,
                              "financial.croissance.allowAccessReview",
                              val
                            )
                          }
                        />
                      </div>
                    </Fragment>
                  )}
                </CollapsePanel>
              </Collapse>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("prestationsPrivileges")} key="6">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={prestations.allowAccess}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "prestations.allowAccess",
                    val
                  )
                }
              />
            </div>
            {prestations.allowAccess &&
              this.renderViewDataBySwitch(
                role,
                "viewDataBy",
                "prestations.allowViewDataBy",
                prestations.allowViewDataBy
              )}
          </CollapsePanel>
          <CollapsePanel header={_("reportingPrivileges")} key="7">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={reporting.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "reporting.allowAccess", val)
                }
              />
            </div>
            {reporting.allowAccess && (
              <Collapse
                defaultActiveKey={["1x"]}
                style={{
                  width: "82%",
                  marginLeft: "9%",
                  backgroundColor: "transparent"
                }}
              >
                <CollapsePanel header="Suivi de Production" key="1x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessProdCapacity")}
                    </span>
                    <Switch
                      name="allowAccessProdCapacity"
                      checked={reporting.production.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.production.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.production.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.production.allowViewDataBy",
                      reporting.production.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Développement Individuel BE" key="2x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessIndivDevBe")}
                    </span>
                    <Switch
                      name="allowAccessIndivDevBe"
                      checked={reporting.individualDevBe.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.individualDevBe.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.individualDevBe.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.individualDevBe.allowViewDataBy",
                      reporting.individualDevBe.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Développement Individuel MA" key="3x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessIndivDevMa")}
                    </span>
                    <Switch
                      checked={reporting.individualDevMa.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.individualDevMa.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.individualDevMa.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.individualDevMa.allowViewDataBy",
                      reporting.individualDevMa.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi d'Echéances" key="4x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessEcheance")}
                    </span>
                    <Switch
                      checked={reporting.echeance.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.echeance.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.echeance.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.echeance.allowViewDataBy",
                      reporting.echeance.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Récapitulatif Bilans" key="5x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessBalanceRecap")}
                    </span>
                    <Switch
                      checked={reporting.recapBalance.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.recapBalance.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.recapBalance.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.recapBalance.allowViewDataBy",
                      reporting.recapBalance.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Calendrier" key="6x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessCalendar")}
                    </span>
                    <Switch
                      checked={reporting.calendar.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.calendar.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.calendar.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.calendar.allowViewDataBy",
                      reporting.calendar.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi de Temps" key="7x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessTimeReport")}
                    </span>
                    <Switch
                      checked={reporting.timesheet.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.timesheet.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.timesheet.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.timesheet.allowViewDataBy",
                      reporting.timesheet.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi des Portefeuilles" key="8x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessPortfolio")}
                    </span>
                    <Switch
                      checked={reporting.portfolio.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.portfolio.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.portfolio.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.portfolio.allowViewDataBy",
                      reporting.portfolio.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Supervision" key="9x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessErrReporting")}
                    </span>
                    <Switch
                      checked={reporting.supervision.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.supervision.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.supervision.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.supervision.allowViewDataBy",
                      reporting.supervision.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Matrice de Congé" key="10x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessVacationMatrix")}
                    </span>
                    <Switch
                      checked={reporting.vacation.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.vacation.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.vacation.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.vacation.allowViewDataBy",
                      reporting.vacation.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Gestion des Plans" key="11x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessPlans")}
                    </span>
                    <Switch
                      checked={reporting.plans.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.plans.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.plans.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.plans.allowViewDataBy",
                      reporting.plans.allowViewDataBy
                    )}
                </CollapsePanel>
                <CollapsePanel header="Suivi des Prestations" key="12x">
                  <div className={"switch"}>
                    <span className="sidebar_role">
                      {_("allowAccessPrestation")}
                    </span>
                    <Switch
                      checked={reporting.prestations.allowAccess}
                      onChange={val =>
                        this.handleParameterChange(
                          role,
                          "reporting.prestations.allowAccess",
                          val
                        )
                      }
                    />
                  </div>
                  {reporting.prestations.allowAccess &&
                    this.renderViewDataBySwitch(
                      role,
                      "viewDataBy",
                      "reporting.prestations.allowViewDataBy",
                      reporting.prestations.allowViewDataBy
                    )}
                </CollapsePanel>
              </Collapse>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("cpPrivileges")} key="8">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={capacityPlanning.allowAccess}
                onChange={val =>
                  this.handleParameterChange(
                    role,
                    "capacityPlanning.allowAccess",
                    val
                  )
                }
              />
            </div>
            {capacityPlanning.allowAccess &&
              this.renderViewDataBySwitch(
                role,
                "viewDataBy",
                "capacityPlanning.allowViewDataBy",
                capacityPlanning.allowViewDataBy
              )}
          </CollapsePanel>
          <CollapsePanel header={_("settingPrivileges")} key="9">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={settings.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "settings.allowAccess", val)
                }
              />
            </div>
            {settings.allowAccess && (
              <Fragment>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCategories")}
                  </span>
                  <Switch
                    checked={settings.allowAccessCategories}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessCategories",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessTaskTypes")}
                  </span>
                  <Switch
                    checked={settings.allowAccessTaskTypes}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessTaskTypes",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCollaborators")}
                  </span>
                  <Switch
                    checked={settings.allowAccessCollaborators}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessCollaborators",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessCalendarSet")}
                  </span>
                  <Switch
                    checked={settings.allowAccessCalendar}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessCalendar",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessParameters")}
                  </span>
                  <Switch
                    checked={settings.allowAccessParameters}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessParameters",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessUsers")}</span>
                  <Switch
                    checked={settings.allowAccessUsers}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessUsers",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowAccessSynchronization")}
                  </span>
                  <Switch
                    checked={settings.allowAccessSynchronization}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessSynchronization",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">
                    {_("allowCoefficientsConfig")}
                  </span>
                  <Switch
                    checked={settings.allowCoefficientsConfig}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowCoefficientsConfig",
                        val
                      )
                    }
                  />
                </div>
                <div className={"switch"}>
                  <span className="sidebar_role">{_("allowAccessModels")}</span>
                  <Switch
                    checked={settings.allowAccessModels}
                    onChange={val =>
                      this.handleParameterChange(
                        role,
                        "settings.allowAccessModels",
                        val
                      )
                    }
                  />
                </div>
              </Fragment>
            )}
          </CollapsePanel>
          <CollapsePanel header={_("timesheetPrivileges")} key="10">
            <div className={"switch"}>
              <span className="sidebar_role">{_("allowAccess")}</span>
              <Switch
                checked={timesheet.allowAccess}
                onChange={val =>
                  this.handleParameterChange(role, "timesheet.allowAccess", val)
                }
              />
            </div>
            {timesheet.allowAccess &&
              this.renderViewDataBySwitch(
                role,
                "viewDataBy",
                "timesheet.allowViewDataBy",
                timesheet.allowViewDataBy
              )}
          </CollapsePanel>
        </Collapse>
      </Fragment>
    );
  }

  renderAuthorizationParameters() {
    const { authParameters } = this.state;
    switch (this.state.activeTab) {
      case "SUPERADMIN":
        return this.renderSettings("superadmin", authParameters.superadmin);
      case "ADMIN":
        return this.renderSettings("admin", authParameters.admin);
      case "PARTNER":
        return this.renderSettings("partner", authParameters.partner);
      case "COLLABORATOR":
        return this.renderSettings("collaborator", authParameters.collaborator);
      case "SUPERVISOR":
        return this.renderSettings("supervisor", authParameters.supervisor);
      case "NONE":
        return this.renderSettings("none", authParameters.none);
      default:
        return null;
    }
  }

  render() {
    const { activeTab } = this.state;
    return (
      <div>
        <div
          className={styles.tab_synchronization}
          style={{ height: "fit-content" }}
        >
          <div className={styles.header}>
            <span>{_("parameterAuth")}</span>
          </div>
          <div
            className={styles.body}
            style={{
              height: "fit-content",
              width: "100%",
              margin: 0,
              boxShadow: "none",
              border: 0
            }}
          >
            <div className={styles.filter_tab}>
              {this.categories.map(category => {
                return (
                  <span
                    className={`${activeTab === category.id &&
                      styles.active_tab}`}
                    onClick={() =>
                      this.setState({
                        activeTab: category.id
                      })
                    }
                  >
                    {category.label}
                  </span>
                );
              })}
            </div>
            <div style={{ padding: "10px 20px" }}>
              {this.renderAuthorizationParameters()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  parameterSettings: state.parameterSettings
});

export default connect(mapStateToProps)(AuthorizationsParameters);



// WEBPACK FOOTER //
// ./src/components/ParameterSettings/AuthorizationsParamaters.js